const Dashboard = () => import("./../components/pages/dashboard.vue").then(m => m.default || m);
const TradingBuy = () => import("./../components/pages/tradingBuy.vue").then(m => m.default || m);
const AssetsList = () => import("./../components/pages/assetsList.vue").then(m => m.default || m);
const ForecastList = () => import("./../components/pages/forecastList.vue").then(m => m.default || m);
const Orders = () => import("./../components/pages/orders.vue").then(m => m.default || m);
const Rates = () => import("./../components/pages/rates.vue").then(m => m.default || m);
const Activity = () => import("./../components/pages/activity/activity.vue").then(m => m.default || m);
const Account = () => import("./../components/pages/account/account.vue").then(m => m.default || m);
const Auth = () => import("./../components/pages/auth.vue").then(m => m.default || m);
const Asset = () => import("./../components/pages/asset.vue").then(m => m.default || m);
const SignUp = () => import("./../components/pages/auth/signUp.vue").then(m => m.default || m);
const SignIn = () => import("./../components/pages/auth/signIn.vue").then(m => m.default || m);
const Forgot = () => import("./../components/pages/auth/forgot.vue").then(m => m.default || m);
const Payment = () => import("./../components/pages/payment.vue").then(m => m.default || m);
const Emixtier = () => import("./../components/pages/emixtier.vue").then(m => m.default || m);
const Contacts = () => import("./../components/pages/contacts.vue").then(m => m.default || m);

const ModerateModal = () => import("./../components/modals/moderate/moderate.vue").then(m => m.default || m);
const RateModal = () => import("./../components/modals/rate/rate.vue").then(m => m.default || m);

const routes = [
  {path: '/trading/buy', component: TradingBuy, name: 'trading-buy'},
  {path: '/orders', component: Orders, name: 'orders'},
  {path: '/about/emixtier', component: Emixtier, name: 'about-emixtier'},
  {path: '/rates', component: Rates, name: 'rates'},
  {path: '/activity', component: Activity, name: 'activity'},
  {path: '/account', component: Account, name: 'account'},
  {path: '/contacts', component: Contacts, name: 'contacts'},
  {path: '/asset/:id', component: Asset, name: 'asset', props: true},
  {
    path: '/forecast/list',
    component: ForecastList,
    name: 'forecast-list',
    props: (route) => ({
      filter: {
        page: route.query.page || 1,
        type: route.query.type || 'all',
      }
    }),
  },
  {
    path: '/assets/list',
    component: AssetsList,
    name: 'assets-list',
    props: (route) => ({
      filter: {
        page: route.query.page || 1,
        type: route.query.type || 'all',
      }
    }),
    children: [
      {
        path: '/asset/:alias/moderate',
        alias: '/assets/moderate/:alias',
        props: {default: false, modal: true},
        name: 'create-moderate',
        components: {
          modal: ModerateModal,
        }
      },
      {
        path: '/asset/:alias/rate',
        alias: '/assets/rate/:alias',
        props: {default: false, modal: true},
        name: 'create-rate',
        components: {
          modal: RateModal,
        }
      }
    ]
  },
  {path: '/dashboard', component: Dashboard, name: 'dashboard'},
  {path: '/payment', component: Payment, name: 'payment'},
  {
    path: '/auth',
    component: Auth,
    children: [
      {
        path: 'signup',
        component: SignUp,
        name: 'signup'
      },
      {
        path: 'forgot',
        component: Forgot,
        name: 'forgot-password'
      },
      {
        path: '/',
        component: SignIn,
        name: 'signin'
      }
    ]
  },
  {path: '/*', redirect: 'dashboard'},
];

// router.beforeResolve((to, from, next) => {
//   if(to.matched.length > 0) {
//     const title = to.matched[0].components.default.pageTitle;
//     if(title) {
//       store.dispatch('settings/setPageTitle', title);
//     }
//   }
//   next();
// });

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js